export const BEANTRAGT = "BEANTRAGT";
export const FREIGEGEBEN = "FREIGEGEBEN";
export const ABGEWIESEN = "ABGEWIESEN";
